<template>
	<sf-modal-layout size="x" :title="title" :show="show" :closeModal="close">
		<div class="sf-table">
			<table>
				<tbody>
					<tr>
						<th class="col-1">{{ getMessage_('MWCC000168') }}</th>
						<td class="col-"><el-input v-model="param.mstCd" /></td>
						<th class="col-1">{{ getMessage_('MWCC000169') }}</th>
						<td class="col-1"><el-input v-model="param.mstCdName" /></td>
						<th class="col-1">{{ getMessage_('MWCC000149') }}</th>
						<td class="col-1"><el-input v-model="param.mstCdDesc" /></td>
					</tr>
					<tr>
						<th class="col-1">{{ getMessage_('MWCC000145') }}</th>
						<td class="col-1"><el-input v-model="param.useYn" /></td>
						<th class="col-1">{{ getMessage_('MWCC000005') }}</th>
						<td class="col-1"><el-input v-model="param.regId" /></td>
						<th class="col-1">{{ getMessage_('MWCC000172') }}</th>
						<td class="col-1"><el-input v-model="param.chgId" /></td>
					</tr>
				</tbody>
			</table>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="close">{{ getMessage_('MWCC000343') }}</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceTaskMethods, serviceTaskComputed } from '@/views/qms/TaskCommCd/store/helpers';
export default {
	props: { isOpen: { type: Boolean, default: false } },
	data() {
		return {
			show: this.isOpen,
			param: '',
			popup2: false
		};
	},
	computed: {
		...rootComputed,
		...serviceTaskComputed,
		title() {
			return this.getMessage_('MWCC000174');
		}
	},
	methods: {
		...rootMethods,
		...serviceTaskMethods,
		open(param) {
			this.show = true;
			this.param = param;
		},
		close() {
			this.show = false;
		}
	}
};
</script>

<style scoped>
.user-managment-items-container {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}
</style>
